import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../components/Button';
import GeoJsonUploadModal from '../components/GeoJsonUploadModal';
import './ToolsPage.css';

const ToolsPage = () => {
  const navigate = useNavigate();
  const [showUploadModal, setShowUploadModal] = useState(false);

  const handleGeoJsonGpxClick = () => {
    setShowUploadModal(true);
  };

  const handleFileUpload = (geoJsonData) => {
    setShowUploadModal(false);
    // Navigate to the map page with GeoJSON data in state
    navigate('/tools/geojson-gpx', { state: { geoJsonData } });
  };

  return (
    <div className="tools-page">
      <div className="tools-page-header">
        <h2>Tools</h2>
      </div>

      <div className="tools-page-content">
        <div className="tools-grid">
          <div 
            className="tool-card tool-card-clickable"
            onClick={handleGeoJsonGpxClick}
            style={{ cursor: 'pointer' }}
          >
            <div className="tool-card-header">
              <span className="tool-type-badge">Converter</span>
            </div>
            <div className="tool-card-body">
              <h4>GeoJSON &lt;&gt; GPX Generator</h4>
              <p className="tool-description">Convert between GeoJSON and GPX formats</p>
            </div>
            <div className="tool-card-footer" onClick={(e) => e.stopPropagation()}>
              <Button
                variant="primary"
                size="small"
                onClick={handleGeoJsonGpxClick}
              >
                Open
              </Button>
            </div>
          </div>

          <div
            className="tool-card tool-card-clickable"
            onClick={() => navigate('/tools/ski-area-dag')}
            style={{ cursor: 'pointer' }}
          >
            <div className="tool-card-header">
              <span className="tool-type-badge" style={{ background: '#a855f7' }}>Graph</span>
            </div>
            <div className="tool-card-body">
              <h4>Ski Area Trail Graph</h4>
              <p className="tool-description">Build and visualize the DAG of runs, lifts, and connections for any ski area</p>
            </div>
            <div className="tool-card-footer" onClick={(e) => e.stopPropagation()}>
              <Button
                variant="primary"
                size="small"
                onClick={() => navigate('/tools/ski-area-dag')}
              >
                Open
              </Button>
            </div>
          </div>

          <div
            className="tool-card tool-card-clickable"
            onClick={() => navigate('/tools/uikit')}
            style={{ cursor: 'pointer' }}
          >
            <div className="tool-card-header">
              <span className="tool-type-badge" style={{ background: '#f59e0b' }}>Designer</span>
            </div>
            <div className="tool-card-body">
              <h4>REKKIE UIKit</h4>
              <p className="tool-description">Live-preview LVGL XML screens and components for the goggle display</p>
            </div>
            <div className="tool-card-footer" onClick={(e) => e.stopPropagation()}>
              <Button
                variant="primary"
                size="small"
                onClick={() => navigate('/tools/uikit')}
              >
                Open
              </Button>
            </div>
          </div>

          <div
            className="tool-card tool-card-clickable"
            onClick={() => navigate('/tools/virtual-goggles')}
            style={{ cursor: 'pointer' }}
          >
            <div className="tool-card-header">
              <span className="tool-type-badge" style={{ background: '#3b82f6' }}>Simulator</span>
            </div>
            <div className="tool-card-body">
              <h4>Virtual Goggles</h4>
              <p className="tool-description">Simulate a goggles device over Firestore — drive the iOS app without physical hardware</p>
            </div>
            <div className="tool-card-footer" onClick={(e) => e.stopPropagation()}>
              <Button
                variant="primary"
                size="small"
                onClick={() => navigate('/tools/virtual-goggles')}
              >
                Open
              </Button>
            </div>
          </div>

          <div
            className="tool-card tool-card-clickable"
            onClick={() => navigate('/tools/intelligence')}
            style={{ cursor: 'pointer' }}
          >
            <div className="tool-card-header">
              <span className="tool-type-badge" style={{ background: '#10b981' }}>AI</span>
            </div>
            <div className="tool-card-body">
              <h4>REKKIE Intelligence</h4>
              <p className="tool-description">Connect an AI client to the REKKIE MCP server, and see what people ask the Offboard Agent in Slack</p>
            </div>
            <div className="tool-card-footer" onClick={(e) => e.stopPropagation()}>
              <Button
                variant="primary"
                size="small"
                onClick={() => navigate('/tools/intelligence')}
              >
                Open
              </Button>
            </div>
          </div>
        </div>
      </div>

      <GeoJsonUploadModal
        isOpen={showUploadModal}
        onClose={() => setShowUploadModal(false)}
        onFileUpload={handleFileUpload}
      />
    </div>
  );
};

export default ToolsPage;

